import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import "moment/locale/id";
import { useState } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../../context/authContext";
import { useLogoutModal } from "../../context/logoutModalContext";
import { useTransaksi } from "../../context/transaksiContext";
import axios from "../../services/axios";
import useShiftNow from "../../services/queries/useShiftNow";
import useUser from "../../services/queries/useUser";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const ModalKonfirmasiLogout = () => {
    const { ukmIdUser, logout, isLoading } = useAuth();
    const { data: user } = useUser();
    const { handleReset } = useTransaksi();
    const { isOpenModalLogout, closeModalLogout } = useLogoutModal();

    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const initialParamsGetShiftNow = {
        ukmId: ukmIdUser && ukmIdUser[0],
        tipe: "now",
    };

    const { data: shiftNow } = useShiftNow(initialParamsGetShiftNow);

    const handleKeluar = async () => {
        setIsButtonLoading(true);
        try {
            if (user?.aksesParkir === 1 && user?.aksesFoodcourt !== 1) {
                const body = {
                    shiftId: shiftNow?.id,
                    kasAkhir: 0,
                };

                const { data } = await axios.post(`/api/shift-end`, body);
                if (data.code === 200) {
                    await Swal.fire({
                        title: "Shift berhasil diakhiri",
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                } else {
                    throw new Error("Gagal mengakhiri shift");
                }
            }

            handleReset();
            logout();
            closeModalLogout();
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Gagal mengakhiri shift",
                text: "Silakan coba lagi",
                toast: true,
                position: "top-end",
                timer: 3000,
                showCloseButton: true,
            });
        } finally {
            setIsButtonLoading(false);
        }
    };

    // const handleKeluar = async () => {
    //     setIsButtonLoading(true);
    //     try {
    //         const body = {
    //             shiftId: shiftNow?.id,
    //             kasAkhir: 0,
    //         };

    //         const { data } = await axios.post(`/api/shift-end`, body);
    //         if (data.code === 200) {
    //             await Swal.fire({
    //                 title: "Shift berhasil diakhiri",
    //                 position: "top-end",
    //                 showConfirmButton: false,
    //                 icon: "success",
    //                 toast: true,
    //                 timer: 3000,
    //                 timerProgressBar: true,
    //                 showCloseButton: true,
    //                 customClass: {
    //                     container: "my-swal",
    //                 },
    //             });

    //             handleReset();
    //             logout();
    //             closeModalLogout();
    //         } else {
    //             throw new Error("Gagal mengakhiri shift");
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         Swal.fire({
    //             icon: "error",
    //             title: "Gagal mengakhiri shift",
    //             text: "Silakan coba lagi",
    //             toast: true,
    //             position: "top-end",
    //             timer: 3000,
    //             showCloseButton: true,
    //         });
    //     } finally {
    //         setIsButtonLoading(false);
    //     }
    // };

    return (
        <>
            <Dialog
                maxWidth="xs"
                fullWidth={true}
                open={isOpenModalLogout}
                onClose={closeModalLogout}
                PaperProps={{
                    sx: {
                        borderRadius: 1,
                    },
                }}
            >
                <DialogTitle>Keluar?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Anda yakin ingin keluar dari aplikasi?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleKeluar}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                        disabled={isButtonLoading}
                    >
                        {isButtonLoading ? "Memproses..." : "Keluar"}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={closeModalLogout}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        Tidak
                    </Button>
                </DialogActions>
            </Dialog>
            <LoadingOverlay open={isLoading} />
        </>
    );
};

export default ModalKonfirmasiLogout;
